import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import ReturnStepType, {
    ReturnStepTypeData,
    ReturnStepTypeDataKeys,
    ReturnStepTypeDisplayOptions,
} from '../../../../components/return-step-type/ReturnStepType';

const ReturnStepTypeColumnTemplate = (props: CellTemplateProps) => {
    return (
        <>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <ReturnStepType
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={props.data}
                        defaultProps={ReturnStepTypeColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </>
    );
};

export const ReturnStepTypeColumnTemplateDefaultProps = {} as ReturnStepTypeDisplayOptions;

export const ReturnStepTypeColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type ReturnStepTypeColumnTemplateData = ReturnStepTypeData & {};

export const ReturnStepTypeColumnTemplateDataKeys = [...ReturnStepTypeDataKeys];

export default ReturnStepTypeColumnTemplate;
